<!-- eslint-disable vue/no-bare-strings-in-template @intlify/vue-i18n/no-raw-text -->
<script setup>
import { onMounted, ref } from 'vue';
import LaisCard from 'dashboard/components-next/LaisCard.vue';
import LaisPrimaryButton from 'dashboard/components-next/LaisPrimaryButton.vue';

const emit = defineEmits([
  'create-first',
  'dismiss',
  'viewed',
  'continue',
  'action-button-clicked',
]);

const STORAGE_KEY = 'lais_shopwindow_onboarding_v1';

const completedSteps = ref(
  (() => {
    try {
      return JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '[]');
    } catch (error) {
      return [];
    }
  })()
);

const STEPS = [
  {
    id: 'know',
    label: 'Conheça as vitrines',
    body: 'Crie coleções dedicadas para clientes específicos.',
  },
  {
    id: 'create',
    label: 'Crie a primeira',
    body: 'Defina nome, descrição e adicione os primeiros imóveis.',
  },
  {
    id: 'share',
    label: 'Compartilhe',
    body: 'Envie o link da vitrine direto para o seu cliente.',
  },
];

const completeStep = id => {
  if (completedSteps.value.includes(id)) return;
  completedSteps.value = [...completedSteps.value, id];
  try {
    window.localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify(completedSteps.value)
    );
  } catch (error) {
    /* no-op */
  }
};

const isComplete = id => completedSteps.value.includes(id);

onMounted(() => {
  emit('viewed', { completed_steps: completedSteps.value.length });
});
</script>

<template>
  <!-- eslint-disable vue/no-bare-strings-in-template @intlify/vue-i18n/no-raw-text -->
  <LaisCard title="Comece com vitrines de imóveis">
    <p class="text-[13px] leading-6 text-lais-text-muted mb-3">
      Vitrines ajudam a apresentar imóveis selecionados para um cliente
      específico, sem perder o controle do funil.
    </p>

    <ol class="grid gap-2">
      <li
        v-for="step in STEPS"
        :key="step.id"
        class="flex items-start justify-between gap-3 rounded-lais border border-lais-border bg-white p-3 text-[13px]"
        :class="{ 'opacity-60': isComplete(step.id) }"
      >
        <div>
          <p class="font-semibold">{{ step.label }}</p>
          <p class="text-lais-text-muted">{{ step.body }}</p>
        </div>
        <button
          v-if="!isComplete(step.id)"
          type="button"
          class="text-[12px] font-semibold text-lais-primary"
          @click="
            completeStep(step.id);
            emit('continue', { step: step.id });
          "
        >
          Marcar feito
        </button>
        <span v-else class="text-[12px] font-semibold text-emerald-700">
          Concluído
        </span>
      </li>
    </ol>

    <template #footer>
      <div class="flex flex-wrap justify-end gap-2">
        <LaisPrimaryButton
          variant="ghost"
          @click="
            emit('action-button-clicked', { action: 'dismiss' });
            emit('dismiss');
          "
        >
          Já conheço
        </LaisPrimaryButton>
        <LaisPrimaryButton
          icon="i-lucide-store"
          @click="
            emit('action-button-clicked', { action: 'create_first' });
            emit('create-first');
          "
        >
          Criar minha primeira vitrine
        </LaisPrimaryButton>
      </div>
    </template>
  </LaisCard>
</template>
